export const DISCOUNTS = {
  CLUB_12: 10,
  CLUB_24: 20,
}
